var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7046 0.295367C11.8938 0.484488 12 0.74099 12 1.00845C12 1.2759 11.8938 1.53241 11.7046 1.72153L7.42616 6L11.7046 10.2785C11.8938 10.4676 12 10.7241 12 10.9916C12 11.259 11.8938 11.5155 11.7046 11.7046C11.5155 11.8938 11.259 12 10.9916 12C10.7241 12 10.4676 11.8938 10.2785 11.7046L6 7.42616L1.72153 11.7046C1.5324 11.8938 1.2759 12 1.00845 12C0.740989 12 0.484487 11.8938 0.295367 11.7046C0.106246 11.5155 -1.12725e-08 11.259 0 10.9916C1.12725e-08 10.7241 0.106246 10.4676 0.295367 10.2785L4.57384 6L0.295367 1.72153C0.106247 1.5324 2.81976e-07 1.2759 2.93248e-07 1.00845C3.0452e-07 0.740989 0.106247 0.484487 0.295367 0.295367C0.484488 0.106247 0.74099 -1.12725e-08 1.00845 0C1.2759 1.12725e-08 1.53241 0.106247 1.72153 0.295367L6 4.57384L10.2785 0.295367C10.4676 0.106247 10.7241 4.09484e-07 10.9916 4.20757e-07C11.259 4.32029e-07 11.5155 0.106247 11.7046 0.295367Z",
    fill: "#00ADEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.3575d1de178009034d1c19028b9baf71.svg";
export { ForwardRef as ReactComponent };